export default "__VITE_ASSET__CTe$P5ws__"